import { Injectable } from "@angular/core";
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { LoopBackAuth } from "./../../shared/sdk/index";
import { PeopleWithrightsInterface } from "../interfaces/peopleWithrights.interface";
import { ROLES } from '../datas/roles.helpers';

/**
 * Decision d'acces a ULTRAnet, isolee du garde pour etre testable.
 * Volontairement independante de AuthGuardAdmin, qui laisse passer tous les
 * profils (ROLES.special contient la liste complete) — cf. spec du lot 1.
 */
export function canAccessUltranet(profilName: string | null | undefined): boolean {
  if (!profilName) { return false; }
  return ROLES.ultranet.indexOf(profilName) > -1;
}

@Injectable()
export class AuthGuardUltranet implements CanActivate {

  user: PeopleWithrightsInterface;

  constructor(
    public router: Router,
    public auth: LoopBackAuth
  ) {
    this.user = this.auth.getCurrentUserData();
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (!canAccessUltranet(this.user?.profil?.name)) {
      this.router.navigate(['/dashboard']);
      return false;
    }
    return true;
  }

}
